/**
 * @module websocket.event.handlers.aircraft.aircraft-deleted
 */
import { store } from '../../../../state/store'
import { setAircraftListUpdated } from '../../../../state/websocket.slice'

export default function handleAircraftDeleted(context) {
  const { payload: { channelId, data } = {} } = context
  if (!data || !channelId) {
    return
  }

  const isSubscribed = store
    .getState()
    ?.websocket?.subscriptions?.some((channel) => channel === channelId)

  console.log('#handleAircraftDeleted', {
    isSubscribed,
    channelId,
    data,
  })

  if (isSubscribed) {
    store.dispatch(setAircraftListUpdated(data))
  }
} 